@file:OptIn(InternalResourceApi::class)

package waifupics.modules.features.gallery.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/waifupics.modules.features.gallery.generated.resources/"

@delegate:ResourceContentHash(111_733_814)
internal val Res.string.close: StringResource by lazy {
      StringResource("string:close", "close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 98, 21),
      ))
    }

@delegate:ResourceContentHash(-1_959_108_374)
internal val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120, 22),
      ))
    }

@delegate:ResourceContentHash(-760_963_424)
internal val Res.string.edit: StringResource by lazy {
      StringResource("string:edit", "edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 143, 20),
      ))
    }

@delegate:ResourceContentHash(-2_067_923_276)
internal val Res.string.gallery_apply: StringResource by lazy {
      StringResource("string:gallery_apply", "gallery_apply", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 164, 29),
      ))
    }

@delegate:ResourceContentHash(-476_756_719)
internal val Res.string.gallery_columns: StringResource by lazy {
      StringResource("string:gallery_columns", "gallery_columns", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 194, 39),
      ))
    }

@delegate:ResourceContentHash(695_408_546)
internal val Res.string.gallery_date: StringResource by lazy {
      StringResource("string:gallery_date", "gallery_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234, 40),
      ))
    }

@delegate:ResourceContentHash(2_055_008_543)
internal val Res.string.gallery_delete_failed: StringResource by lazy {
      StringResource("string:gallery_delete_failed", "gallery_delete_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 275, 61),
      ))
    }

@delegate:ResourceContentHash(-1_273_642_767)
internal val Res.string.gallery_deleted: StringResource by lazy {
      StringResource("string:gallery_deleted", "gallery_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 387, 35),
      ))
    }

@delegate:ResourceContentHash(1_568_017_680)
internal val Res.string.gallery_deleted_count: StringResource by lazy {
      StringResource("string:gallery_deleted_count", "gallery_deleted_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337, 49),
      ))
    }

@delegate:ResourceContentHash(1_125_583_698)
internal val Res.string.gallery_density: StringResource by lazy {
      StringResource("string:gallery_density", "gallery_density", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 423, 43),
      ))
    }

@delegate:ResourceContentHash(455_900_121)
internal val Res.string.gallery_deselect_group: StringResource by lazy {
      StringResource("string:gallery_deselect_group", "gallery_deselect_group", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 467, 58),
      ))
    }

@delegate:ResourceContentHash(962_649_165)
internal val Res.string.gallery_empty_text: StringResource by lazy {
      StringResource("string:gallery_empty_text", "gallery_empty_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 526, 114),
      ))
    }

@delegate:ResourceContentHash(-239_105_740)
internal val Res.string.gallery_fast_scroll: StringResource by lazy {
      StringResource("string:gallery_fast_scroll", "gallery_fast_scroll", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 641, 59),
      ))
    }

@delegate:ResourceContentHash(-265_173_008)
internal val Res.string.gallery_grouping: StringResource by lazy {
      StringResource("string:gallery_grouping", "gallery_grouping", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 701, 40),
      ))
    }

@delegate:ResourceContentHash(1_143_838_980)
internal val Res.string.gallery_image_layout: StringResource by lazy {
      StringResource("string:gallery_image_layout", "gallery_image_layout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 742, 44),
      ))
    }

@delegate:ResourceContentHash(-490_451_309)
internal val Res.string.gallery_image_load_failed: StringResource by lazy {
      StringResource("string:gallery_image_load_failed", "gallery_image_load_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 787, 61),
      ))
    }

@delegate:ResourceContentHash(734_051_133)
internal val Res.string.gallery_layout: StringResource by lazy {
      StringResource("string:gallery_layout", "gallery_layout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1165, 42),
      ))
    }

@delegate:ResourceContentHash(-301_734_391)
internal val Res.string.gallery_layout_auto: StringResource by lazy {
      StringResource("string:gallery_layout_auto", "gallery_layout_auto", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 849, 39),
      ))
    }

@delegate:ResourceContentHash(29_589_604)
internal val Res.string.gallery_layout_custom: StringResource by lazy {
      StringResource("string:gallery_layout_custom", "gallery_layout_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 889, 37),
      ))
    }

@delegate:ResourceContentHash(2_513_316)
internal val Res.string.gallery_layout_day: StringResource by lazy {
      StringResource("string:gallery_layout_day", "gallery_layout_day", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 927, 30),
      ))
    }

@delegate:ResourceContentHash(1_419_311_310)
internal val Res.string.gallery_layout_grid: StringResource by lazy {
      StringResource("string:gallery_layout_grid", "gallery_layout_grid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 958, 35),
      ))
    }

@delegate:ResourceContentHash(2_013_553_144)
internal val Res.string.gallery_layout_month: StringResource by lazy {
      StringResource("string:gallery_layout_month", "gallery_layout_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 994, 36),
      ))
    }

@delegate:ResourceContentHash(574_711_020)
internal val Res.string.gallery_layout_proportions: StringResource by lazy {
      StringResource("string:gallery_layout_proportions", "gallery_layout_proportions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1114, 50),
      ))
    }

@delegate:ResourceContentHash(-355_912_718)
internal val Res.string.gallery_layout_proportions_description: StringResource by lazy {
      StringResource("string:gallery_layout_proportions_description", "gallery_layout_proportions_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1031, 82),
      ))
    }

@delegate:ResourceContentHash(2_100_313_471)
internal val Res.string.gallery_load_failed: StringResource by lazy {
      StringResource("string:gallery_load_failed", "gallery_load_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1208, 59),
      ))
    }

@delegate:ResourceContentHash(-1_861_794_834)
internal val Res.string.gallery_metadata_not_saved: StringResource by lazy {
      StringResource("string:gallery_metadata_not_saved", "gallery_metadata_not_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1268, 106),
      ))
    }

@delegate:ResourceContentHash(-2_035_141_771)
internal val Res.string.gallery_period: StringResource by lazy {
      StringResource("string:gallery_period", "gallery_period", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1375, 34),
      ))
    }

@delegate:ResourceContentHash(739_415_200)
internal val Res.string.gallery_restore_failed: StringResource by lazy {
      StringResource("string:gallery_restore_failed", "gallery_restore_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1410, 78),
      ))
    }

@delegate:ResourceContentHash(-1_910_449_398)
internal val Res.string.gallery_retry: StringResource by lazy {
      StringResource("string:gallery_retry", "gallery_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1489, 33),
      ))
    }

@delegate:ResourceContentHash(519_513_274)
internal val Res.string.gallery_saved_image: StringResource by lazy {
      StringResource("string:gallery_saved_image", "gallery_saved_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1523, 55),
      ))
    }

@delegate:ResourceContentHash(-703_006_781)
internal val Res.string.gallery_select_group: StringResource by lazy {
      StringResource("string:gallery_select_group", "gallery_select_group", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1579, 56),
      ))
    }

@delegate:ResourceContentHash(-932_069_844)
internal val Res.string.gallery_this_month: StringResource by lazy {
      StringResource("string:gallery_this_month", "gallery_this_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1636, 42),
      ))
    }

@delegate:ResourceContentHash(-120_496_940)
internal val Res.string.gallery_today: StringResource by lazy {
      StringResource("string:gallery_today", "gallery_today", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1679, 29),
      ))
    }

@delegate:ResourceContentHash(767_795_137)
internal val Res.string.gallery_undated: StringResource by lazy {
      StringResource("string:gallery_undated", "gallery_undated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1709, 47),
      ))
    }

@delegate:ResourceContentHash(1_080_439_948)
internal val Res.string.gallery_undo: StringResource by lazy {
      StringResource("string:gallery_undo", "gallery_undo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1757, 28),
      ))
    }

@delegate:ResourceContentHash(1_231_615_722)
internal val Res.string.gallery_viewer_photo: StringResource by lazy {
      StringResource("string:gallery_viewer_photo", "gallery_viewer_photo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1786, 52),
      ))
    }

@delegate:ResourceContentHash(-1_701_615_368)
internal val Res.string.gallery_viewer_position: StringResource by lazy {
      StringResource("string:gallery_viewer_position", "gallery_viewer_position", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1839, 47),
      ))
    }

@delegate:ResourceContentHash(-909_857_306)
internal val Res.string.gallery_yesterday: StringResource by lazy {
      StringResource("string:gallery_yesterday", "gallery_yesterday", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1887, 37),
      ))
    }

@delegate:ResourceContentHash(-1_341_073_907)
internal val Res.string.image: StringResource by lazy {
      StringResource("string:image", "image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2044, 21),
      ))
    }

@delegate:ResourceContentHash(43_466_318)
internal val Res.string.image_actions: StringResource by lazy {
      StringResource("string:image_actions", "image_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1925, 33),
      ))
    }

@delegate:ResourceContentHash(-1_256_700_796)
internal val Res.string.image_information: StringResource by lazy {
      StringResource("string:image_information", "image_information", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1959, 49),
      ))
    }

@delegate:ResourceContentHash(-772_430_875)
internal val Res.string.image_size: StringResource by lazy {
      StringResource("string:image_size", "image_size", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2009, 34),
      ))
    }

@delegate:ResourceContentHash(-444_934_251)
internal val Res.string.save_to_gallery: StringResource by lazy {
      StringResource("string:save_to_gallery", "save_to_gallery", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2066, 43),
      ))
    }

@delegate:ResourceContentHash(1_938_990_645)
internal val Res.string.saved_on: StringResource by lazy {
      StringResource("string:saved_on", "saved_on", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2110, 28),
      ))
    }

@delegate:ResourceContentHash(1_399_273_930)
internal val Res.string.selected_count: StringResource by lazy {
      StringResource("string:selected_count", "selected_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2139, 42),
      ))
    }

@delegate:ResourceContentHash(-1_977_898_449)
internal val Res.string.share: StringResource by lazy {
      StringResource("string:share", "share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2182, 21),
      ))
    }

@delegate:ResourceContentHash(-976_373_893)
internal val Res.string.text_copied_to_clipboard: StringResource by lazy {
      StringResource("string:text_copied_to_clipboard", "text_copied_to_clipboard", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2204, 64),
      ))
    }

@delegate:ResourceContentHash(-1_611_161_934)
internal val Res.string.use_as: StringResource by lazy {
      StringResource("string:use_as", "use_as", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2269, 22),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("close", Res.string.close)
  map.put("delete", Res.string.delete)
  map.put("edit", Res.string.edit)
  map.put("gallery_apply", Res.string.gallery_apply)
  map.put("gallery_columns", Res.string.gallery_columns)
  map.put("gallery_date", Res.string.gallery_date)
  map.put("gallery_delete_failed", Res.string.gallery_delete_failed)
  map.put("gallery_deleted", Res.string.gallery_deleted)
  map.put("gallery_deleted_count", Res.string.gallery_deleted_count)
  map.put("gallery_density", Res.string.gallery_density)
  map.put("gallery_deselect_group", Res.string.gallery_deselect_group)
  map.put("gallery_empty_text", Res.string.gallery_empty_text)
  map.put("gallery_fast_scroll", Res.string.gallery_fast_scroll)
  map.put("gallery_grouping", Res.string.gallery_grouping)
  map.put("gallery_image_layout", Res.string.gallery_image_layout)
  map.put("gallery_image_load_failed", Res.string.gallery_image_load_failed)
  map.put("gallery_layout", Res.string.gallery_layout)
  map.put("gallery_layout_auto", Res.string.gallery_layout_auto)
  map.put("gallery_layout_custom", Res.string.gallery_layout_custom)
  map.put("gallery_layout_day", Res.string.gallery_layout_day)
  map.put("gallery_layout_grid", Res.string.gallery_layout_grid)
  map.put("gallery_layout_month", Res.string.gallery_layout_month)
  map.put("gallery_layout_proportions", Res.string.gallery_layout_proportions)
  map.put("gallery_layout_proportions_description", Res.string.gallery_layout_proportions_description)
  map.put("gallery_load_failed", Res.string.gallery_load_failed)
  map.put("gallery_metadata_not_saved", Res.string.gallery_metadata_not_saved)
  map.put("gallery_period", Res.string.gallery_period)
  map.put("gallery_restore_failed", Res.string.gallery_restore_failed)
  map.put("gallery_retry", Res.string.gallery_retry)
  map.put("gallery_saved_image", Res.string.gallery_saved_image)
  map.put("gallery_select_group", Res.string.gallery_select_group)
  map.put("gallery_this_month", Res.string.gallery_this_month)
  map.put("gallery_today", Res.string.gallery_today)
  map.put("gallery_undated", Res.string.gallery_undated)
  map.put("gallery_undo", Res.string.gallery_undo)
  map.put("gallery_viewer_photo", Res.string.gallery_viewer_photo)
  map.put("gallery_viewer_position", Res.string.gallery_viewer_position)
  map.put("gallery_yesterday", Res.string.gallery_yesterday)
  map.put("image", Res.string.image)
  map.put("image_actions", Res.string.image_actions)
  map.put("image_information", Res.string.image_information)
  map.put("image_size", Res.string.image_size)
  map.put("save_to_gallery", Res.string.save_to_gallery)
  map.put("saved_on", Res.string.saved_on)
  map.put("selected_count", Res.string.selected_count)
  map.put("share", Res.string.share)
  map.put("text_copied_to_clipboard", Res.string.text_copied_to_clipboard)
  map.put("use_as", Res.string.use_as)
}
